export default __webpack_public_path__ + "static/media/buildings.dd877b36.png";